import { GlobalSIFCompliance } from "./GlobalSIFCompliance";
export default GlobalSIFCompliance;
